interface BrandLogoProps {
  ariaLabel?: string;
}

export function BrandLogo({ ariaLabel }: BrandLogoProps) {
  const accessibleProps = ariaLabel
    ? { "aria-label": ariaLabel, role: "img" as const }
    : { "aria-hidden": true };

  return (
    <svg viewBox="0 0 64 64" className="h-7 w-7 text-accent" {...accessibleProps}>
      <path
        fill="currentColor"
        d="M32 6c7 0 13 6 13 13v2h4a7 7 0 0 1 7 7v20c0 5.5-4.5 10-10 10H18C12.5 58 8 53.5 8 48V28a7 7 0 0 1 7-7h4v-2c0-7 6-13 13-13Zm0 8a5 5 0 0 0-5 5v2h10v-2a5 5 0 0 0-5-5Zm-9 15a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm18 0a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z"
      />
    </svg>
  );
}
